module.exports = {
  "dof-card-item": {
    "paddingLeft": "32",
    "paddingRight": "32"
  },
  "dof-card-item-content": {
    "borderTopStyle": "solid",
    "borderTopWidth": "1",
    "borderTopColor": "#f6f7f9"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-1f40ec0d!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-card-item/index.vue
// module id = 435
// module chunks = 0 1